<template>
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" style="fill: transparent !important; stroke: none !important;">
    <rect width="16" height="16" />
  </svg>
</template>